import { Routes } from '@angular/router';
import * as URLS from './URLS';

export const routes: Routes = [
  // {
  //   path: URLS.HOME,
  //   loadChildren: () => import('./features/home/home.routes').then((r) => r.routes)
  // },
  {
    path: URLS.MATERIALS,
    loadChildren: () => import('./features/materials/materials.routes').then((r) => r.routes)
  },
  {
    path: URLS.MIXTURES,
    loadChildren: () => import('./features/mixtures/mixtures.routes').then((r) => r.routes)
  },
  {
    path: '',
    loadChildren: () => import('./features/mixtures/mixtures.routes').then((r) => r.routes)
  }
];
